import { breakpoints, theme } from '@notino/react-styleguide';

import { CdnImage } from '@components/CdnImage';
import { styled } from '@linaria/react';

export const Wrapper = styled.div`
  margin-top: 0.25rem;

  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 1fr 1fr;

  @media (min-width: ${breakpoints.lg}) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;

export const PerfumerImage = styled(CdnImage)`
  width: 3rem;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 50%;
`;

export const PerfumerItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  ${theme.typography.bodyRegular}
`;
